import { render } from "./order_refund.vue?vue&type=template&id=324c02d9"
import script from "./order_refund.vue?vue&type=script&lang=js"
export * from "./order_refund.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__